import React from 'react'
import injectJss from 'react-jss'
import compose from 'recompose/compose'
import PreviewTitleDescription from './PreviewTitleDescription'

const style = theme => ({
    textPreview: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        pointerEvents: 'all',
        // Mount animation
        animationName: 'mountAnimation',
        animationDuration: '0.1s',
        animationDelay: '-0.1s',
        animationIterationCount: '1',
        animationTimingFunction: 'ease-out',
        animationFillMode: 'forwards',
    },
    '@keyframes mountAnimation': {
        '0%': {
            opacity: 0,
            top: 16,
        },
        '100%': {
            opacity: 1,
            top: 0,
        },
    },
})

const TextPreview = ({ classes, title, description, isVisible, onMouseLeave }) => (
    <div className={classes.textPreview} onMouseLeave={onMouseLeave}>
        <PreviewTitleDescription
            title={title}
            description={description}
            leftOffset="10"
            isVisible={true}
            offsetX={0}
            offsetY={0}
        />
    </div>
)

export default compose(injectJss(style))(TextPreview)
